module.exports = __webpack_public_path__ + "static/media/oled.fd39fb1d.png";